import React from "react";
import PossibleMerge from "../../../../../../mapComponents/Markers/Dispatch/PossibleMerge";
import StyledToolTip from "../../../../../../common/StyledToolTip";
import { withStyles, IconButton } from "@material-ui/core";

const styles = (theme) => ({
  iconButton: {
    padding: 0,
  },
});

const RendererIcon = withStyles(styles)(({ classes, title, icon, onClick }) => {
  return (
    <StyledToolTip title={title}>
      {onClick ? (
        <IconButton classes={{ root: classes.iconButton }} onClick={onClick}>
          {icon}
        </IconButton>
      ) : (
        <div>{icon}</div>
      )}
    </StyledToolTip>
  );
});

const PickupIndicatorIconRenderer = ({ context, data }) => {
  const duplicatePickups = context.getSelectedPickupsDuplicate(data.pickupId);
  if (Boolean(duplicatePickups?.length)) {
    return (
      <RendererIcon
        title="Possible merge"
        icon={<PossibleMerge />}
        onClick={context.handlePossibleMergeClick(
          data.pickupId?.toLowerCase()
        )}
      />
    );
  }
  return data.isMergedPickup ? (
    <RendererIcon
      title={`Merged to ${data.pickupMergedTo}`}
      icon={<i className="icon-merge-routes" />}
    />
  ) : null
};

export default PickupIndicatorIconRenderer;
